var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyStep8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1805_8817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3125 95.6953V1.69531H1.06641V95.6953H95.3125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1805_8817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2128 65.2457C66.1687 82.8083 58.4207 95.2891 49.3435 95.2891C43.7038 95.2891 38.5776 90.472 34.7734 82.6118",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 31.6425C32.6664 14.3451 40.3528 2.10211 49.3435 2.10211C58.4074 2.10211 66.1458 14.5463 69.1994 32.0684",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0665 72.4727C30.4658 70.2568 29.9464 67.9222 29.5176 65.4892",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5381 55.4199C18.4561 51.7453 15.0856 47.9591 12.5781 44.2729",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2361 42.0477C88.2308 52.8762 94.0426 64.6602 89.7986 71.992C83.9309 82.1294 61.0618 79.9169 38.7193 67.0505C37.7642 66.5003 36.8258 65.9399 35.9043 65.3699",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96566 34.5117C7.15058 31.0827 7.40304 27.9676 8.88997 25.3988C14.7576 15.2617 37.6268 17.4742 59.9692 30.3406C60.9505 30.9057 61.9143 31.4819 62.86 32.068",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2363 55.3438C88.0145 44.711 93.8311 33.1569 90.0198 25.8011",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7305 76.4004C44.7476 74.5541 52.3888 71.4151 59.9693 67.0498C60.9547 66.4824 61.9225 65.9036 62.8721 65.3148",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5176 41.989C10.4789 52.8338 4.63837 64.647 8.88993 71.9922C11.7177 76.8773 18.4935 78.8944 27.2562 78.2335",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6601 19.8524C71.6063 17.2364 55.0227 20.952 38.7191 30.3407C37.7378 30.9059 36.7739 31.482 35.8281 32.0684",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2553 35.778H24.1969C23.4085 35.778 22.7695 36.4155 22.7695 37.2019V63.8224C22.7695 64.6088 23.4085 65.2461 24.1969 65.2461H46.251",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5156 65.2461H74.4913C75.2799 65.2461 75.9187 64.6088 75.9187 63.8224V37.2019C75.9187 36.4155 75.2799 35.778 74.4913 35.778H71.6686",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4922 47.1735V58.2386C27.4922 59.0248 28.1311 59.6621 28.9195 59.6621H49.3436V37.839C49.3436 34.6939 46.7877 32.1444 43.6345 32.1444H28.9195C28.1311 32.1444 27.4922 32.7817 27.4922 33.5679V40.9252",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4922 58.2384V55.391C27.4922 54.6049 28.1311 53.9675 28.9195 53.9675H43.6345C46.7875 53.9675 49.3436 56.517 49.3436 59.6621H28.9195C28.1311 59.6621 27.4922 59.0246 27.4922 58.2384Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3236 59.6621H69.7681C70.5563 59.6621 71.1954 59.0248 71.1954 58.2384V33.5679C71.1954 32.7817 70.5563 32.1442 69.7681 32.1442H55.0533C51.8999 32.1442 49.3438 34.6939 49.3438 37.8388V59.6621H58.0595",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1952 55.3912C71.1952 54.605 70.5563 53.9675 69.7679 53.9675H55.0531C51.8997 53.9675 49.3438 56.5172 49.3438 59.6621",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2598 37.5586H42.2013",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2598 42.4941H42.2013",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2598 47.4277H42.2013",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4883 37.5586H65.4296",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4883 42.4941H65.4296",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4883 47.4277H65.4296",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6264 21.9165C91.6264 24.7165 89.3509 26.9863 86.5436 26.9863C83.7364 26.9863 81.4609 24.7165 81.4609 21.9165C81.4609 19.1164 83.7364 16.8467 86.5436 16.8467C89.3509 16.8467 91.6264 19.1164 91.6264 21.9165Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7301 77.5415C37.7301 80.3416 35.4544 82.6113 32.6473 82.6113C29.8401 82.6113 27.5645 80.3416 27.5645 77.5415C27.5645 74.7416 29.8401 72.4717 32.6473 72.4717C35.4544 72.4717 37.7301 74.7416 37.7301 77.5415Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9176 39.5808C14.9176 42.3807 12.6419 44.6504 9.83477 44.6504C7.02765 44.6504 4.75195 42.3807 4.75195 39.5808C4.75195 36.7806 7.02765 34.511 9.83477 34.511C12.6419 34.511 14.9176 36.7806 14.9176 39.5808Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyStep8);
export default __webpack_public_path__ + "static/media/metodology-step8.7b262dbed59a115b53cc0c0a5ee826a2.svg";
export { ForwardRef as ReactComponent };